<script lang="ts">
const __DsBlock = {
	name: '$t:blocks.cards.name',
	icon: 'lucide:layout-grid',
	category: 'layout',
	type: 'listing-layout',
	hidden: true,
	events: [
		{
			name: 'open',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
		{
			name: 'update:displayOptions',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
	],
	slots: ['actions'],
}
</script>
<script lang="ts" setup generic="T">
import type { CompositePrimaryKey } from '#layers/data-model';
import type { CardsDisplayOptions } from '~/components/Layout/Cards/LayoutCards.vue';
import type { SharedLayoutEmits, SharedLayoutProps } from '~/types/layout';
import { defineBlock } from '#layers/block-engine';

interface LayoutCardsBlockProps extends SharedLayoutProps<CardsDisplayOptions> {}

defineProps<LayoutCardsBlockProps>();

defineEmits<Pick<SharedLayoutEmits, 'open' | 'update:displayOptions'>>();

const selection = defineModel<CompositePrimaryKey[]>('selection', { default: () => [] });

;
</script>

<template>
	<LayoutCards
		v-bind="$props"
		v-model:selection="selection"
		@open="$emit('open', $event)"
		@update:display-options="$emit('update:displayOptions', $event)"
	/>
</template>
